import api from "../core/http";

/**
 * Upcoming and recently released movies / show seasons for a cinematic
 * universe (public, cached by the API).
 * - uses react-query
 * @param {string} franchise mcu | dcu | dceu | star_wars
 * @param {{upcomingLimit?: number, releasedLimit?: number}} limits
 */
export const getScreenReleases = (franchise, limits = {}) => {
  return api
    .get("/v1/screen-releases", {
      params: {
        franchise,
        upcoming_limit: limits.upcomingLimit ?? 3,
        released_limit: limits.releasedLimit ?? 3,
      },
    })
    .then((res) => res.data);
};

/**
 * One movie / show season with its linked reading orders.
 * - uses react-query
 */
export const getScreenRelease = (releaseId) => {
  return api.get(`/v1/screen-releases/${releaseId}`).then((res) => res.data);
};
